import React from "react";
import { ImBlogger2 } from "react-icons/im";
import { IoMdTime } from "react-icons/io";
import { FaRegUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import blog1 from "../images/blog1.jpeg";
import blog2 from "../images/blog2.jpeg";
import blog3 from "../images/blog3.png";
import blog4 from "../images/blog4.jpeg";

const blogs = [
  {
    id: 1,
    title: "Exploring Liquibase: Transforming Software Development with Eas",
    decription:
      "Liquibase facilitates seamless database schema management by providing an open-source platform to track and implement schema modifications",
    image: blog1,
    href: "https://www.linkedin.com/feed/update/urn:li:activity:7190368981805912064/",
  },
  {
    id: 2,
    title:
      "🎉We're thrilled to announce that our Excel-based Insurance System has been honored with a Certificate of Recognition,",
    decription:
      "We're thrilled to announce that our Excel-based Insurance System has been honored with a Certificate of Recognition, thanks to the esteemed Mukesh Sharma and Abhishek Ambastha",
    image: blog2,
    href: "https://www.linkedin.com/feed/update/urn:li:activity:7183828855508328448/",
  },
  {
    id: 3,
    title: "🔐🌐Securing the Digital Frontier: The Impact of SSL!",
    decription:
      "Ever wondered about the padlock in your browser's address bar? 🤔 SSL stands for Secure Sockets Layer. Think of it as a virtual bodyguard for your data when it travels between your device and the websites you visit. It's like s",
    image: blog3,
    href: "https://www.linkedin.com/feed/update/urn:li:activity:7166830540560572417/",
  },
  {
    id: 4,
    title:
      "👨‍💻 Let's talk about something that can make or break your web app's API calls - Cross-Origin Resource Sharing (CORS)🌐✨",
    decription:
      "CORS is a security feature implemented by web browsers to control how web pages in one domain can request and interact with resources on another domain",
    image: blog4,
    href: "https://www.linkedin.com/posts/iramansharma73_cors-techtalk-websecurity-activity-7149676523707416576-Nn-f/?utm_source=share&utm_medium=member_desktop",
  },
];

const BlogSection = () => {
  return (
    <div
      name="blog"
      className="w-full bg-gradient-to-b from-black via-gray to-gray-800"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col justify-center h-full text-white">
        <div className="max-w-screen-xl mx-auto p-5">
          <div className="border-b flex justify-between text-sm">
            <div className=" flex items-center pb-2 ">
              <span className="mr-2">
                <ImBlogger2 style={{ color: "black", background: "white" }} />
              </span>
              <Link to="/" className="font-semibold inline-block">
                Latest Blogs
              </Link>
            </div>
            <Link
              to="https://www.linkedin.com/in/iramansharma73/recent-activity/all/"
              target="_blank"
            >
              See All
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-2">
            {blogs.map(({ id, title, decription, image, href }) => (
              <div
                key={id}
                className="rounded overflow-hidden shadow-lg flex flex-col"
              >
                <div className="relative">
                  <img
                    className="w-full h-full object-cover"
                    style={{ height: "200px" }}
                    src={image}
                    alt={title.substring(0, 10)}
                  />
                  <div className="hover:bg-transparent transition duration-300 absolute bottom-0 top-0 right-0 left-0 bg-gray-900 opacity-25"></div>
                </div>
                <div className=" mb-auto">
                  <Link
                    to={href}
                    target="_blank"
                    className="font-medium text-lg inline-block hover:text-teal-500 transition duration-300 ease-in-out cursor-pointer"
                  >
                    {title.substring(0, 45)}...
                  </Link>
                  <p className="text-gray-500 text-sm pb-2">
                    {decription.substring(0, 50)}...
                  </p>
                </div>
                <div className="px-2 py-3 flex flex-row items-center justify-between bg-gray-100">
                  <span className=" text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                    <span className="text-teal-500">
                      <IoMdTime size={14} />
                    </span>
                    <span className="ml-1">15 days ago</span>
                  </span>
                  <span className="py-1 text-xs font-regular text-gray-900 mr-1 flex flex-row items-center">
                    <span className="text-teal-500">
                      <FaRegUser />
                    </span>
                    <span className="ml-1 ">Raman Sharma</span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
